import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { IParticipantSectionsContext } from './ParticipantSectionsContext';
import { getSectionNavigationInfo } from './helpers';
import {
  getStepNavigationInfo,
  updateParticipantStepStatus,
} from '../ParticipantStepsDataProvider/helpers';
import memoize from 'lodash/memoize';
import {
  addOnLoginHandler,
  IOnLoginHandlerPriority,
} from '../GeneralDataProvider/helpers/onLogin';
import { getParticipantSectionsV3 } from './GetParticipantSectionsV3';
import {
  extendedStepMap,
  requestParticipantStep,
  updateExtendedStepMap,
} from './requestParticipantStep';
import { requestParticipantSection } from './requestParticipantSection';
import { getDetails } from '../../selectors/step';

const updateParticipantsSections = async (flowAPI: ControllerFlowAPI) => {
  const { sections, steps } = await getParticipantSectionsV3(flowAPI);

  flowAPI.controllerConfig.setProps({
    listParticipantSections: sections,
    participantSteps: { steps },
  });
};

const handleSectionsAfterLogin = () => {
  addOnLoginHandler({
    priority: IOnLoginHandlerPriority.SECONDARY,
    handler: async (flowAPI: ControllerFlowAPI) => {
      const { sections, steps } = await getParticipantSectionsV3(flowAPI);
      return flowAPI.controllerConfig.setProps({
        listParticipantSections: sections,
        participantSteps: { steps },
        isListParticipantSectionsRequestInProgress: false,
      });
    },
  });
};

export const participantSectionsPropsMap = memoize(async function (
  flowAPI: ControllerFlowAPI,
): Promise<IParticipantSectionsContext> {
  const { sections, steps } = await getParticipantSectionsV3(flowAPI);
  const [selectedSection, { selectedStep }] = await Promise.all([
    getSectionNavigationInfo(flowAPI, sections),
    getStepNavigationInfo(flowAPI, steps),
  ]);

  void handleSectionsAfterLogin();

  if (getDetails(selectedStep?.source)) {
    updateExtendedStepMap(selectedStep.source, selectedStep.id);
  }

  return {
    selectedStep,
    extendedStepMap,
    selectedSection,
    participantSteps: { steps },
    listParticipantSections: sections,
    isListParticipantSectionsRequestInProgress: false,
    isParticipantStepsLoading: false,
    updateParticipantSections: () => updateParticipantsSections(flowAPI),
    updateParticipantSteps: async () => {
      //todo implement or use updateParticipantsSections
    },
    updateParticipantStepStatus: async (payload) =>
      updateParticipantStepStatus(flowAPI, payload),
    requestParticipantSectionStatus: 'INITIAL',
    requestParticipantSection: async (sectionId, lSections) =>
      requestParticipantSection(sectionId, lSections, flowAPI),
    requestParticipantStep: async (stepId) =>
      requestParticipantStep(stepId, flowAPI),
  };
});
